import { render, staticRenderFns } from "./Accessibility.vue?vue&type=template&id=2f24bc41&"
import script from "./Accessibility.vue?vue&type=script&lang=js&"
export * from "./Accessibility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports